// ── Spectator UI overlay ──

import type { GameState } from '../game/state';
import { getCurrentUid } from '../firebase';
import { joinGame } from '../sync/client';

export interface SpectatorCallbacks {
  onJoinAsPlayer: (gameId: string, name: string) => void;
}

/** Check if the current user is a spectator (not a player) */
export function isSpectator(state: GameState): boolean {
  const uid = getCurrentUid();
  if (!uid) return true;
  return (
    state.meta.player1?.uid !== uid && state.meta.player2?.uid !== uid
  );
}

/** Render the "Join as Player 2" prompt for spectators if the slot is open */
export function renderJoinPrompt(
  container: HTMLElement,
  state: GameState,
  gameId: string,
  callbacks: SpectatorCallbacks,
): void {
  // Only show if game is waiting and player2 slot is open
  if (state.meta.status !== 'waiting' || state.meta.player2) return;

  const existing = container.querySelector('.spectator-join');
  if (existing) return;

  const prompt = document.createElement('div');
  prompt.className = 'spectator-join';
  prompt.innerHTML = `
    <p>This game needs a second player.</p>
    <input type="text" class="input-name" id="spectator-name" placeholder="Your name" maxlength="20" autocomplete="off" />
    <button class="btn btn-primary" id="btn-spectator-join">Join Game</button>
  `;

  container.appendChild(prompt);

  const btn = prompt.querySelector('#btn-spectator-join') as HTMLButtonElement;
  const nameInput = prompt.querySelector('#spectator-name') as HTMLInputElement;

  btn.addEventListener('click', () => {
    const name = nameInput.value.trim() || 'Player 2';
    callbacks.onJoinAsPlayer(gameId, name);
    prompt.remove();
  });
}
